/**
 * Pełny zestaw ikon lucide (~1500, nazwa → komponent) — dla pickera ikon menu w Kreatorze i do
 * rozwiązywania ikony menu po zapisanej nazwie. Cała biblioteka i tak jest w głównym bundlu
 * (`import * as LucideIcons` w polach ikon i przyciskach tabeli), więc dostęp jest synchroniczny
 * i nie kosztuje dodatkowego ładowania.
 */

import { icons, type LucideIcon } from 'lucide-react';

export type LucideIconMap = Record<string, LucideIcon>;

export const ALL_LUCIDE_ICONS = icons as unknown as LucideIconMap;

/** Ikona po nazwie z pełnego zestawu (undefined = nieznana nazwa). */
export function resolveLucideIcon(name: string | null | undefined): LucideIcon | undefined {
  return name ? ALL_LUCIDE_ICONS[name] : undefined;
}
